export const TOGGLE_ITEM  = 'TOGGLE_ITEM';
export const TOGGLE_ITEMS = 'TOGGLE_ITEMS';
export const RESET_ITEMS  = 'RESET_ITEMS';
export const TOGGLE_ITEM_DROP_DOWN   = 'TOGGLE_ITEM_DROP_DOWN';
export const RESET_ITEM_DROP_DOWN   = 'RESET_ITEM_DROP_DOWN';
export const SELECTED_ITEM_ID   = 'SELECTED_ITEM_ID';
export const RESET_ITEM_ID   = 'RESET_ITEM_ID';



// WEBPACK FOOTER //
// ./src/store/modules/select/mutations.js